/**
 * Tutorial Completion Utilities
 * Helper functions to award badges and track tutorial completion
 */
import { apiClient } from './apiClient';
import { getTutorialByTourId } from '../data/tours';
/**
 * Award badge for completing a tour
 * Works from any page (What's New, Learning Center, etc.)
 * Fetches current profile first to avoid overwriting existing badges
 */
export async function awardBadgeForTour(tourId, userId, currentCompletedTutorials = [], currentEarnedBadges = [], totalTutorials = 1) {
    try {
        console.log('🏅 awardBadgeForTour called for tour:', tourId);
        // Get tutorial metadata from tour ID
        const tutorialMeta = getTutorialByTourId(tourId);
        if (!tutorialMeta) {
            console.warn('⚠️ No tutorial metadata found for tour:', tourId);
            return { success: false, error: 'Tutorial not found' };
        }
        console.log('📚 Found tutorial:', tutorialMeta.title);
        // Fetch current profile to get latest badges
        console.log('📡 Fetching current profile to get latest badges...');
        const profileResponse = await apiClient.get('auth-profile');
        let currentCompleted = [];
        let currentBadges = [];
        if (profileResponse.ok && profileResponse.data?.profile?.profile?.tutorials) {
            currentCompleted = profileResponse.data.profile.profile.tutorials.completedTutorials || [];
            currentBadges = profileResponse.data.profile.profile.tutorials.earnedBadges || [];
            console.log('📊 Current badges from profile:', currentBadges.length);
        }
        // Check if already completed
        if (currentCompleted.includes(tutorialMeta.tutorialId)) {
            console.log('ℹ️ Tutorial already completed - skipping badge award');
            return { success: true };
        }
        // Add to completed tutorials
        const updatedCompleted = [...currentCompleted, tutorialMeta.tutorialId];
        // Create new badge
        const newBadge = {
            ...tutorialMeta.badge,
            earnedDate: new Date().toISOString()
        };
        const updatedBadges = [...currentEarnedBadges, newBadge];
        // Calculate completion percentage
        const totalCompletionPercentage = Math.round((updatedCompleted.length / totalTutorials) * 100);
        console.log('📤 Updating profile with badge:', {
            tutorial: tutorialMeta.tutorialId,
            badge: newBadge.name,
            percentage: totalCompletionPercentage
        });
        // Update profile via auth-profile API
        const response = await apiClient.put('auth-profile', {
            profile: {
                tutorials: {
                    completedTutorials: updatedCompleted,
                    earnedBadges: updatedBadges,
                    totalCompletionPercentage,
                    lastActivityDate: new Date().toISOString()
                }
            }
        });
        if (response.ok) {
            console.log('✅ Badge awarded successfully!');
            return { success: true };
        }
        else {
            console.error('❌ Failed to award badge:', response.error);
            return { success: false, error: response.error };
        }
    }
    catch (error) {
        console.error('❌ Error awarding badge:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Unknown error'
        };
    }
}
